/**
 * work-mode.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { Types } from 'utils/constants';


const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    minWidth: theme.spacing(14),
    maxWidth: theme.spacing(14),
    lineHeight: '1rem',
    textTransform: 'none',
    borderColor: theme.palette.sys.outline,
  },
  selected: {
    borderColor: 'transparent',
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.sys.onPrimary,
      '&.Mui-disabled': {
        opacity: 0.6
      }
    },
  }
}));


export default function WorkMode(props) {
  const {
    formContext: formContextProp,
    disabled,
  } = props;
  const classes = useStyles();

  const formContextDefault = useFormContext();
  const formContext = formContextProp || formContextDefault;


  return (
    <Controller
      control={formContext.control}
      name='workMode'
      render={({ field: { ref, value, onChange, ...inputProps } }) => (
        <ToggleButtonGroup
          value={value}
          onChange={(e, newVal) => {
            if (newVal) onChange(newVal);
          }}
          exclusive
          data-testid='workMode-control'
        >
          <ToggleButton
            classes={classes}
            value={Types.WorkMode.DETECTION}
            disabled={disabled}
            data-testid={`workMode-option-${Types.WorkMode.DETECTION}`}
          >
            Detection
          </ToggleButton>
          <ToggleButton
            classes={classes}
            value={Types.WorkMode.PATROL}
            disabled={disabled}
            data-testid={`workMode-option-${Types.WorkMode.PATROL}`}
          >
            Patrol
          </ToggleButton>
        </ToggleButtonGroup>
      )}
    />
  );
}